// extracted by mini-css-extract-plugin
export default {"attentionContainer":"style--attentionContainer--84e2b7","textareaContainer":"style--textareaContainer--febdd5","textarea":"style--textarea--06dd7a"};